import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { useAppStore } from './store';
import 'katex/dist/katex.min.css';
import './index.css';

document.documentElement.classList.toggle('dark', useAppStore.getState().theme === 'dark');
const client = new QueryClient({
  defaultOptions: { queries: { staleTime: 20_000, retry: 2 }, mutations: { retry: 0 } },
});
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
